import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { PersonState } from '../../../../../core/states/offer/offer.state';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { getPersons } from '../../../../../core/states/offer/offer.selector';
import { UntilDestroy } from '@ngneat/until-destroy';
import { map } from 'rxjs/operators';
import { RemoveSupplementaryInsuranceEvent } from '../basket.component';

interface BasketPerson {
  person: PersonState;
  open: boolean;
  isActivePerson: boolean;
}

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'ssc-basket-accordion',
  templateUrl: './basket-accordion.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasketAccordionComponent implements OnChanges {
  @Input() public activePersonId: number | undefined;
  @Input() public isTupCustomer: boolean | null;

  @Output() public personClick = new EventEmitter<number>();
  @Output() public removeBasicInsuranceClick = new EventEmitter<number>();
  @Output() public removeSupplementaryInsuranceClick = new EventEmitter<RemoveSupplementaryInsuranceEvent>();

  public basketPersons$: Observable<BasketPerson[]>;
  public openIndex: number | undefined;

  constructor(private store: Store) {}

  public onClick(index: number): void {
    this.openIndex = this.openIndex === index ? undefined : index;
  }

  public ngOnChanges(): void {
    this.basketPersons$ = this.store.select(getPersons).pipe(
      map((persons) =>
        persons.map((person) => ({
          person,
          open: person.personId === this.activePersonId,
          isActivePerson: person.personId === this.activePersonId,
        })),
      ),
    );
  }
}
